<template>
    <v-container :key="id">
        <h1 class="v-card__title text-uppercase justify-center">{{ metaData.header }}</h1>
        <v-row>
            <v-col xs="12">
                <v-tabs
                    v-model="tab"
                    centered
                    slider-color="orange"
                >
                    <v-tab
                            v-for="item in tabsData"
                            :key="item.key"
                    >
                        {{ item.title }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                            v-for="item in tabsData"
                            :key="item.key"
                    >
                        <v-card flat>
                            <v-card-text>
                                <GeneralInfo
                                        v-if="item.key === tabs.general"
                                        :tab-data="item"
                                        :data-key="tabs.general"
                                        @update="updateUser"
                                        @save="saveData"
                                />
                                <CompanyInfo
                                        v-if="item.key === tabs.company"
                                        :tab-data="item"
                                        :data-key="tabs.company"
                                        @update="updateUser"
                                        @save="saveData"
                                />
                                <CommercialPolicyInfo
                                        v-if="isSeller && item.key === tabs.commercialPolicy"
                                        :tab-data="item"
                                        :data-key="tabs.commercialPolicy"
                                        @update="updateUser"
                                        @save="saveData"
                                />
                                <BusinessInfo
                                        v-if="item.key === tabs.business"
                                        :tab-data="item"
                                        :data-key="tabs.business"
                                        :user="userID"
                                        :is-seller="isSeller"
                                        @update="updateUser"
                                />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
        <edit-snackbar
                v-model="isOpenEditSnack"
                :snack-text="editSnackText"
                :snack-color="editSnackColor"
                @close="resetEditSnack"
        ></edit-snackbar>
    </v-container>
</template>

<script>
    import { UsersService } from "../../../services"
    import { GeneralInfo, BusinessInfo, CompanyInfo, CommercialPolicyInfo } from "./tab-content"
    import { EditSnackbar } from "../../../components/snackbars"
    import { MixinEditSnack } from "../../../mixins"

    export default {
        name: "Details",
        props: ['id'],
        mixins: [MixinEditSnack],
        components: {
            GeneralInfo,
            BusinessInfo,
            CommercialPolicyInfo,
            CompanyInfo,
            EditSnackbar
        },
        data() {
            return {
                tabs: {
                    general: 'generalInfo',
                    company: 'companyInfo',
                    business: 'businessInfo',
                    commercialPolicy: 'commercialPolicyInfo'
                },
                metaUrl: '/users/details/' + this.id,
                userData: null,
                userDataUpdated: {},
                tab: null,
            }
        },
        computed: {
            tabsData() {
                if(!this.userData)
                    return [];

                let items =  Object.values(this.userData);

                if(!this.isSeller) {
                    return items.filter(item => item.key !== this.tabs.commercialPolicy)
                }

                return items;
            },
            userID() {
                return this.userData ? this.userData[this.tabs.general].id : false;
            },
            isBuyer() {
                return this.userData ? this.userData[this.tabs.general].isBuyer : false;
            },
            isSeller() {
                return this.userData ? !!this.userData[this.tabs.general].isSeller : false;
            }
        },
        methods: {
            getTabTitle(key) {
                switch(key) {
                    case this.tabs.general: return 'Общая информация';
                    case this.tabs.company: return 'Информация о компании';
                    case this.tabs.commercialPolicy: return 'Коммерческая политика';
                    case this.tabs.business: return 'Бизнес-информация';

                    default: return '';
                }
            },
            setData() {
                UsersService.setAuth(this.$store.getters.token);
                UsersService.getDetails(this.id)
                    .then((res) => {
                        this.setUser(res.data);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            setUser(userData) {
                this.userDataUpdated = userData;
                for (let i  in userData) {
                    if(userData[i]) {
                        userData[i].title = this.getTabTitle(i);
                        userData[i].key = i;
                    } else {
                        delete(userData[i]);
                    }
                }

                this.userData = userData;
            },
            updateUser(user) {
                this.userData[user.key] = user.data;
                this.setUser(this.userData);
            },
            saveData() {
                UsersService.setAuth(this.$store.getters.token);
                UsersService.fullUpdateUser(this.userDataUpdated)
                    .then((res) => {
                        if(res.data.error) {
                            this.handleSavingError(res.data.error);
                        } else {
                            this.handleSavingSuccess(res.data.userData);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.openErrorEditSnack();
                    });
            },
            handleSavingSuccess(userData) {
                this.setUser(userData);
                this.openSuccessEditSnack();
            },
            handleSavingError() {
                this.openErrorEditSnack();
            }
        },
        created() {
            this.setData();
        }
    }
</script>

<style scoped>

</style>